import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

// Components
import AuditTrail from "./AuditTrail";

//Actions
import { getAuditTrailAction } from "./AuditTrailAction";

//Strings
import { Strings } from "../Translations/i18n";

//Constants
import { API_RESPONSE_STATUS_CODES } from "../Utils/Constants";
import {
  ACTION_TYPE_FOR_ADMIN_AUDIT,
  ACTION_TYPE_FOR_LOAN_AUDIT_AUDIT,
  AUDIT_TYPE,
} from "./Constants";

class AuditTrailContainer extends Component {
  constructor(props) {
    super(props);
    this.getAuditTrailActionFilter(this.props.auditTrailReducer.auditType);

    this.state = {
      errorMessage: "",
      auditTrailData: [],
      numberOfPages: 0,
      isExpandable:
        this.props.auditTrailReducer.auditType === AUDIT_TYPE.CONFIGURATOR_AUDIT
          ? false
          : true,
    };
  }
  getAuditTrailActionFilter = (auditType) => {
    let auditTrailActionFilter = [{ value: "", name: "selectUserAction" }];
    if (auditType === AUDIT_TYPE.ADMIN_AUDIT) {
      auditTrailActionFilter = ACTION_TYPE_FOR_ADMIN_AUDIT;
    } else if (auditType === AUDIT_TYPE.LOAN_AUDIT) {
      auditTrailActionFilter = ACTION_TYPE_FOR_LOAN_AUDIT_AUDIT;
    }
    return auditTrailActionFilter;
  };

  createSecondRowData = () => {
    this.state.auditTrailData.forEach((auditTrail, index) => {
      let auditTrailData = [...this.state.auditTrailData];
      if (auditTrail.oldData) {
        let newData =
          typeof auditTrail.newData !== "object"
            ? JSON.parse(auditTrail.newData)
            : auditTrail.newData;
        let oldData =
          typeof auditTrail.oldData !== "object"
            ? JSON.parse(auditTrail.oldData)
            : auditTrail.oldData;
        let data = _.uniq([...Object.keys(oldData), ...Object.keys(newData)]);
        let differentKeys = [];
        let diff = [];

        for (const key of data) {
          if (!_.isEqual(oldData[key], newData[key])) {
            differentKeys.push(key);
          }
        }
        diff = differentKeys.map((key) => {
          return {
            key: key,
            oldData: oldData[key],
            newData: newData[key],
          };
        });
        auditTrailData[index]["secondRowData"] = diff;
      } else if (auditTrail.oldData == null && auditTrail.newData == null) {
        let diff = [];

        diff = [
          {
            key: "ProfilePicChanged",
            oldData: null,
            newData: null,
          },
        ];
        auditTrailData[index]["secondRowData"] = diff;
      } else {
        let newData =
          typeof auditTrail.newData !== "object"
            ? JSON.parse(auditTrail.newData)
            : auditTrail.newData;

        let diff = [];
        let differentKeys = Object.keys(newData);
        diff = differentKeys.map((key) => {
          return {
            key: key,
            oldData: "N/A",
            newData: newData[key],
          };
        });
        auditTrailData[index]["secondRowData"] = diff;
      }

      this.setState({
        auditTrailData,
      });
    });
  };

  getAuditTrail = (data) => {
    let request = {
      ...data,
      auditType: this.props.auditTrailReducer.auditType,
      performedOn: this.props.auditTrailReducer.performedOn
        ? this.props.auditTrailReducer.performedOn
        : undefined,
    };
    getAuditTrailAction(request, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        let auditTrailData = responseData.data.data;
        this.setState(
          {
            errorMessage: "",
            auditTrailData,
            numberOfPages: responseData.data.numberOfPages,
          },
          () => {
            this.props.auditTrailReducer.auditType !==
              AUDIT_TYPE.CONFIGURATOR_AUDIT && this.createSecondRowData();
          }
        );
      } else {
        this.setState({
          errorMessage: Strings(responseData.error.message),
        });
      }
    });
  };

  render() {
    let header;
    if (this.props.auditTrailReducer.auditType === AUDIT_TYPE.ADMIN_AUDIT) {
      header = this.props.auditTrailReducer.userName;
    } else if (
      this.props.auditTrailReducer.auditType === AUDIT_TYPE.LOAN_AUDIT
    ) {
      header = this.props.auditTrailReducer.performedOn;
    }
    return (
      <div>
        <AuditTrail
          auditTrailData={this.state.auditTrailData}
          getAuditTrail={this.getAuditTrail}
          numberOfPages={this.state.numberOfPages}
          header={header}
          isExpandable={this.state.isExpandable}
          auditTrailReducer={this.props.auditTrailReducer}
          getAuditTrailActionFilter={this.getAuditTrailActionFilter}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auditTrailReducer: state.auditTrailReducer,
  };
}

export default connect(mapStateToProps)(AuditTrailContainer);
